import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./carousel.css";
import "./Fooditems.css";

const FoodItems = () => {
  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 6,
    autoplay: false, // Enable autoplay
    autoplaySpeed: 1500,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="container-fluid Food-items-bg">
        <div className="fooditems-heading container pt-4 pb-3">
          <h2 className="title-fooditem">Inspiration for Your First Order</h2>
        </div>
        <div className="img-container container">
          <div className="row">
            <Slider {...settings}>
              <a href="">
                <div className="col-lg-3 col-md-3 food-items-img">
                  <img
                    src="https://images.unsplash.com/photo-1626645738196-c2a7c87a8f58?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80 "
                    alt=""
                  />
                  <p className="img-name">Chicken</p>
                </div>
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3 food-items-img">
                  <img
                    src="https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=481&q=80"
                    alt=""
                  />
                  <p className="img-name">Pizza</p>
                </div>
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3 food-items-img">
                  <img
                    src="https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1780&q=80"
                    alt=""
                  />
                  <p className="img-name">Pasta</p>
                </div>
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3 food-items-img">
                  <img
                    src="https://images.unsplash.com/photo-1586816001966-79b736744398?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
                    alt=""
                  />
                  <p className="img-name">Burger</p>
                </div>
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3 food-items-img">
                  <img
                    src="https://images.unsplash.com/photo-1589302168068-964664d93dc0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80"
                    alt=""
                  />
                  <p className="img-name">Briyani</p>
                </div>
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3 food-items-img">
                  <img
                    src="https://images.unsplash.com/photo-1625398407796-82650a8c135f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=580&q=80"
                    alt=""
                  />
                  <p className="img-name">Traditional</p>
                </div>
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3 food-items-img">
                  <img
                    src="https://images.unsplash.com/photo-1606471191009-63994c53433b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=327&q=80"
                    alt=""
                  />
                  <p className="img-name">Chicken Gravy</p>
                </div>
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3 food-items-img">
                  <img
                    src="https://images.unsplash.com/photo-1603133872878-684f208fb84b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=725&q=80"
                    alt=""
                  />
                  <p className="img-name">Fried Rice</p>
                </div>
              </a>
              <a href="">
                <div className="col-lg-3 col-md-3 food-items-img">
                  <img
                    src="https://images.unsplash.com/photo-1528736235302-52922df5c122?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1254&q=80"
                    alt=""
                  />
                  <p className="img-name">SandWich</p>
                </div>
              </a>
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default FoodItems;
